import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  position: absolute;
  bottom: 0;

  width: 100%;
  height: 70px;
  background-color: #212224;

>div {
    flex: 1;
}
`;

const Contacts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  svg {
    margin-bottom: -2px;
  }

  a {
    text-decoration: none !important;
  }
`;

const Title = styled.div`
  padding: 2px 27px;
  width: fit-content;
  border-radius: 0px 0px 8px 8px;
  background: linear-gradient(180deg, #D78E28 0%, #F4D974 100%);

  color: #0E1017;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

const ContactsListContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: center;
  margin: 0 0 21px 0;
`

const LightText = styled.div`
  color: #FFF;
  font-size: 14px;
  font-style: normal;
  font-weight: 200;
  line-height: normal;
`;

const PhoneBox = styled.div`
  display: flex;
  gap: 4px;
  margin-top: 6px;
  margin-bottom: 1px;
`;



const ContactsBox = () => {
  const { t } = useTranslation();
  const { settings: { social_links } } = useSelector(state => state.app);

  return (
    <Container >
      {/* {social_links?.phones?.length > 0 && */}
      <Contacts>
        <Title>
          {t("message.contactTitle")}
        </Title>
        <ContactsListContainer>
          {
            social_links?.phones?.length > 0 && social_links.phones.map((phone, index) => (
              <a href={`tel:${phone}`} key={index}>
                <PhoneBox>
                  <LightText>{phone}</LightText>
                </PhoneBox>
              </a>
            ))
          }
          {/* <a href={`tel:${social_links?.phones[0]}`} >
            <PhoneBox>
              <LightText>{social_links?.phones[0]}</LightText>
            </PhoneBox>
          </a>
          <a href={`tel:${social_links?.phones[1]}`}>
            <PhoneBox>
              <LightText>{social_links?.phones[1]}</LightText>
            </PhoneBox>
          </a>
          <a href={`tel:${social_links?.phones[1]}`}>
            <PhoneBox>
              <LightText>{social_links?.phones[1]}</LightText>
            </PhoneBox>
          </a> */}
        </ContactsListContainer>

      </Contacts>
      {/* } */}
    </Container>
  );
}

export default ContactsBox;